<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-row justify="center" align="center">
        <v-col lg="10" cols="12" sm="10" md="10">
          <ChartsHeatmap :dataSource="dataSource" v-if="!loading" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import ChartsHeatmap from "../charts/ApexChartsHeatmap.vue";
export default {
  name: "messages_time",
  components: {
    ChartsHeatmap,
  },
  data() {
    return {
      loading: false,
      dataSource: {
        height: 550,
        type: "heatmap",
        series: [],
        chartOptions: {
          plotOptions: {
            heatmap: {
              radius: 2,
              enableShades: true,
              shadeIntensity: 0.5,
              reverseNegativeShade: true,
              distributed: false,
              useFillColorAsStroke: false,
              colorScale: {
                ranges: [
                  {
                    from: 0,
                    to: 0.005,
                    color: "#909090",
                    name: this.$t("analytics.conversations.messages_time.none"),
                  },
                  {
                    from: 0.005,
                    to: 2,
                    color: "#00A100",
                    name: this.$t("analytics.conversations.messages_time.low"),
                  },
                  {
                    from: 2,
                    to: 5,
                    color: "#FFB200",
                    name: this.$t(
                      "analytics.conversations.messages_time.medium"
                    ),
                  },
                  {
                    from: 5,
                    to: 100,
                    color: "#E50202",
                    name: this.$t("analytics.conversations.messages_time.high"),
                  },
                ],
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            theme: "dark",
            y: {
              formatter: function (val) {
                return (val > 0 ? val.toFixed(2) : val) + "%";
              },
            },
          },
          title: {
            text: "",
          },
          xaxis: {
            tooltip: {
              enabled: false,
            },
          },
          yaxis: {
            title: {
              text: "GMT+2",
            },
          },
          stroke: {
            width: 1,
          },
        },
      },
    };
  },
  computed: {
    messages_time() {
      const data = this.$store.state.analytics.MessagesTime;
      return data;
    },
  },
  async created() {
    this.loading = true;
    if (this.messages_time) await this.init_vals();
    this.loading = false;
  },
  methods: {
    init_vals() {
      this.dataSource.series = [];
      const days = [
        this.$t("daysOfweek.monday"),
        this.$t("daysOfweek.tuesday"),
        this.$t("daysOfweek.wednesday"),
        this.$t("daysOfweek.thursday"),
        this.$t("daysOfweek.friday"),
        this.$t("daysOfweek.saturday"),
        this.$t("daysOfweek.sunday"),
      ];
      for (var i = 23; i >= 0; i -= 1) {
        const toPush = {
          name: `${i < 10 ? "0" : ""}${i}:00`,
          data: [],
        };
        for (const day of days) {
          toPush.data.push({
            x: day,
            y: 0,
          });
        }
        this.dataSource.series.push(toPush);
      }
      if (this.messages_time) {
        for (const data of this.messages_time) {
          const hod_index = data.hour_of_day;
          const dow_index = data.day_of_week == 0 ? 6 : data.day_of_week - 1; // Indexed with sunday at 0 in Postgres
          const s = this.dataSource.series[hod_index - 2];
          s.data[dow_index].y += data.percentage_of_total;
        }
      }
    },
  },
};
</script>
